'use client';

import useSwiperNavigation from '@/hooks/shared/useSwiperNavigation';

import AboutNewsRoomHeader from '@/components/apps/pages/about/AboutNewsRoomHeader';

const NEWS_PLACEHOLDERS = Array.from({ length: 3 }, (_, index) => index);

export function AboutNewsFallback() {
  const { nextElRef, prevElRef } = useSwiperNavigation();

  return (
    <section className="bg-apps-brandGray900 py-[clamp(100px,10.417vw,200px)]">
      <AboutNewsRoomHeader nextElRef={nextElRef} prevElRef={prevElRef} />
      <div
        aria-hidden="true"
        className="grid grid-cols-1 gap-[24px] px-[20px] sm:grid-cols-2 min-[1560px]:px-[calc((100%_-_1480px)/2)] lg:grid-cols-3"
      >
        {NEWS_PLACEHOLDERS.map((placeholder) => (
          <div
            key={placeholder}
            className="motion-safe:animate-pulse first:block sm:last:hidden lg:last:block"
          >
            <div className="aspect-[220/124] rounded-[15px] bg-apps-brandGray800 lg:aspect-[447/268] lg:rounded-[20px]" />
            <div className="px-[8px] pt-[16px] lg:px-[16px] lg:pt-[24px]">
              <div className="h-[20px] w-[96px] rounded bg-apps-brandGray800" />
              <div className="mt-[12px] h-[28px] w-4/5 rounded bg-apps-brandGray800" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export function AboutPhoneFallback() {
  return (
    <span
      aria-hidden="true"
      className="inline-block h-[20px] w-[120px] motion-safe:animate-pulse rounded bg-apps-brandGray800 align-middle"
    />
  );
}
